<template>
  <modal ref="modal" :playground="true" :title="title" @hidden="resetForm">
    <form @submit.prevent="submit">
      <div class="uk-modal-body">
        <product-family-combobox v-model="form.model.productFamily"
                                 :errors="form.errors.productFamily"
                                 :disabled="!isEditable"
                                 :filter="{ bundle: false }" />
      </div>
      <div class="uk-modal-footer uk-text-right">
        <submit-button type="primary" :disabled="!isSubmittable">
          {{$t('actions.add')}}
        </submit-button>
        <common-button @click="hide">
          {{$t('actions.cancel')}}
        </common-button>
      </div>
    </form>
  </modal>
</template>

<script>
import pick from 'lodash/pick';
import Authentication from '@/mixins/Authentication';
import CommonButton from '@/components/CommonButton';
import Form from '@/mixins/LegacyForm';
import Modal from '@/components/Modal';
import productFamiliesQuery from '@/api/queries/product-families.graphql';
import ProductFamilyCombobox from '@/components/ProductFamilyCombobox';
import SubmitButton from '@/components/SubmitButton';

export default {
  name: 'product-family-bundling-form',
  props: {
    title: String,
  },
  components: {
    CommonButton,
    Modal,
    ProductFamilyCombobox,
    SubmitButton,
  },
  mixins: [
    Authentication,
    Form({
      productFamily: {
        required: true,
        serializeTo: 'productFamilyId',
        serialize: family => family.id,
      },
    }),
  ],
  apollo: {
    availableProductFamilies: {
      query: productFamiliesQuery,
      variables: {
        sort: { field: 'NAME', direction: 'ASC' },
        pagination: { page: 1, size: 1000 },
      },
      fetchPolicy: 'network-only',
      update({ productFamilies }) {
        return productFamilies.entries.map(family =>
          pick(family, ['id', 'name']),
        );
      },
      skip() {
        return !this.isAuthenticated;
      },
    },
  },
  methods: {
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    resetForm() {
      this.form.model.productFamily = null;
      this.form.errors.productFamily = [];
    },
  },
  i18n: {
    messages: {
      de: {
        fields: {
          productFamily: 'Produktfamilie',
        },
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// ProductFamilyBundlingForm.vue?08fbfb8c